import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Overview from "@/pages/Overview";
import Users from "@/pages/Users";
import Workers from "@/pages/Workers";
import Pickups from "@/pages/Pickups";
import Revenue from "@/pages/Revenue";
import Analytics from "@/pages/Analytics";
import Notifications from "@/pages/Notifications";
import Subscriptions from "@/pages/Subscriptions";
import UserMap from "@/pages/UserMap";
import LocalMapAssessment from "@/pages/LocalMapAssessment";
import RouteDesign from "@/pages/RouteDesign";
import ContentManagement from "@/pages/ContentManagement";
import DailyCollections from "@/pages/DailyCollections";
import Tickets from "@/pages/Tickets";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";

import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/overview" replace />} />
            <Route path="overview" element={<Overview />} />
            <Route path="users" element={<Users />} />
            <Route path="daily-coverage" element={<DailyCollections />} />
            <Route path="map" element={<UserMap />} />
            <Route path="local-map-assessment" element={<LocalMapAssessment />} />
            <Route path="route-design" element={<RouteDesign />} />
            <Route path="workers" element={<Workers />} />
            <Route path="pickups" element={<Pickups />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="content" element={<ContentManagement />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;